import { logDatapoint } from '../logDatapoint';
import ProfilerDatapoint from '../../datapoints/ProfilerDatapoint';

export function logProfilerDatapoint(scenario: string, duration: number, trace: string): void {
    logDatapoint(new ProfilerDatapoint(scenario, duration, trace), 'client_trace');
}
